import AlertComponent from "./AlertComponent";

export default AlertComponent;
